import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ShareLinkService } from '../../services/Share-Link/share-link.service';

@Component({
  selector: 'app-dynamic-modal-embed-tool',
  templateUrl: './dynamic-modal-embed-tool.component.html',
  styleUrls: ['./dynamic-modal-embed-tool.component.css']
})
export class DynamicModalEmbedToolComponent implements OnInit {
  html: any;
  htmlCheckbox: any
  isReadOnly = true
  expiryValue = false;
  showCheckobox = true
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public shareLinkService: ShareLinkService) { }

  ngOnInit(): void {
    this.html = this.data.html;
    this.htmlCheckbox = this.data.htmlCheckbox
    if(this.htmlCheckbox) {
      this.isReadOnly = true;
      this.showCheckobox = false
    } else {
      this.isReadOnly = false;
    }
  }

  term(e: any): void {
    if (e.target.checked) {
      this.isReadOnly = false;
      this.expiryValue = true;
    } else {
      this.isReadOnly = true;
    }
  }
  close(): void {
    this.shareLinkService.dialogTemplate.close();
  }
}
